import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroPhoneNumberField, { IIntroPhoneNumberField } from "../Components/IntroPhoneNumberField";

/** A Text Field for gathering the Phone Number.
 * Controlled from the Session Context.
 */
const SessionContextPhoneNumberField = SessionContextValueProvider({
  Component: IntroPhoneNumberField,
  map: ({ duplicateCustomers, unverifiedCustomer, setCustomer, setUnverifiedCustomer }) => {
    return {
      value: unverifiedCustomer.phoneNumber,
      onChangeValue: (phoneNumber: string) => setUnverifiedCustomer(c => ({ ...c, phoneNumber: phoneNumber })),
      onChange: (phoneNumber: string) => setCustomer(c => ({ ...c, phoneNumber: phoneNumber })),
      isDuplicate: duplicateCustomers.some(c => c.phoneNumber === unverifiedCustomer.phoneNumber)
    } as IIntroPhoneNumberField;
  }
});

export default SessionContextPhoneNumberField;
